module.exports = __webpack_public_path__ + "img/web-land-1.39846156.webp";